<script>
	import Bubble from '$lib/Components/Layout/Bubble/Bubble.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Parallax from '$lib/Components/Parallax/Parallax.svelte';
	import Youtube from '$lib/Components/Youtube/Youtube.svelte';
	import Awards from '$lib/PageSections/Awards/Awards.svelte';
	import FeaturedArticles from '$lib/PageSections/FeaturedArticles/FeaturedArticles.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import GradeTypes from '$lib/PageSections/GradeTypes/GradeTypes.svelte';

	import image3 from './images/commercial-grade-bottom.png';
	import image1 from './images/commercial-grade-image-001.png';
	import image2 from './images/commercial-grade-image-002.png';
</script>

<Section backgroundColor={'white'}>
	<h2>Scratch Resistant Window Insulation Panels</h2>
	<p>
		Commercial Grade is our most durable window insert for achieving quiet,
		energy savings, and a more comfortable work environment. <a
			href="/commercial-storm-windows/office-soundproofing">Increase your ROI</a
		> with these scratch-resistant window inserts. Ideal for commercial sites, they
		have a tougher exterior than our Standard Grade. Use them at home where the inserts
		need to be industrial strength – whether because blinds, kids, or pets might
		bump against them, or they need to be frequently removed and cleaned.
	</p>
	<Image src={image1} alt="Window insulation panels." />
	<p>
		Interested in soundproofing your space? Commercial Grade also comes in the
		same thickness as Acoustic Grade to block 70 percent of outside noise.*
		Whether you’re a facility manager, hotelier or architect, learn more about
		the benefits of using Indow inserts in commercial settings by visiting our <a
			href="/commercial-storm-windows">commercial pages</a
		>.
	</p>
</Section>

<Section backgroundColor={'white'}>
	<h2>How do Abrasion-Resistant Inserts Work?</h2>
	<p>
		Since most windows are out of square, every opening is laser measured so we
		can custom make each abrasion-resistant window insert for a precise, snug
		fit. They’re edged in our silicone compression tubing to seal out drafts and
		noise. Visually, they’re no different than Standard or <a
			href="/custom-storm-windows/museum-grade">Museum Grade</a
		>.
	</p>
	<p>
		The abrasion-resistant coating protects your inserts and your windows better
		than anti-scratch window film. Anti-scratch window film adheres to your
		window glass, where Indow inserts press into your window frame (leaving no
		residue and providing soundproofing). Our inserts also provide higher
		clarity and protection than anti-scratch window film. Customers have
		reported kids throwing balls into windows without any damage.
	</p>
	<Bubble title="Commercial Grade Inserts are:">
		<ul>
			<li>
				Made from ⅛” or ¼” acrylic glazing, depending on how much outside noise
				you want to reduce.
			</li>
			<li>Covered in an abrasion resistant coating.</li>
			<li>Available in warm white, brown and black silicone tubing colors.</li>
			<li>
				Nearly invisible once installed, blending in with existing window
				frames.
			</li>
		</ul>
	</Bubble>

	<Youtube
		src="https://www.youtube.com/embed/qxM4_xEanY0"
		title="Indow Customer Testimonial - Historic Preservation for Commercial Spaces"
	/>

	<Bubble title="How our Durable Inserts Perform:">
		<ul>
			<li>
				Can be cleaned with regular cleaning products; great for locations with
				routine cleaning crews.
			</li>
			<li>
				50 percent reduction in noise when ⅛” acrylic placed over single-pane
				windows, 70 percent reduction with ¼” acrylic.
			</li>
			<li>
				20 percent average energy savings. (Read this U.S. Department of Energy
				study on Indow)
			</li>
		</ul>
	</Bubble>
	<a class="!text-indow-blue text-xl italic" href="/solutions/noise-performance"
		>Explore complete noise reduction data here.</a
	>
	<a
		class="!text-indow-blue text-xl italic"
		href="/solutions/comfort-performance"
		>Explore complete energy savings data here.</a
	>
</Section>

<Section backgroundColor={'white'}>
	<h2>Testimonials on our Durable Window Inserts</h2>
	<p>
		Our commercial grade inserts were used in a famous Alcatraz exhibit by the
		artist Ai Weiwei to protect the National Historic Landmark’s windows. The
		former federal penitentiary in the San Francisco Bay draws 1.3 million
		visitors annually to view the cells of famous criminals like Al Capone and
		George “Machine-Gun” Kelly.
	</p>
	<p>
		Commercial grade inserts are also <a
			href="/commercial-storm-windows/hotel-soundproofing">popular in hotels</a
		>. 21 Broad in Nantucket used Indow inserts for commercial window insulation
		and soundproofed their street-facing rooms.
	</p>
	<p class="!text-indow-blue text-xl italic">
		“It was such a drastic difference. It was night and day,” said manager Dan
		Matter. “We’re 100% confident it will handle all the noise complaints
		generated from the street.”
	</p>
	<Image src={image2} alt="Commercial window insulation." />
	<p class="text-sm italic">
		*We want to ensure our inserts help solve your noise problem. Overall noise
		reduction depends on the amount of noise coming through your walls,
		ceilings, floors, doors, and existing windows. Noise reduction will be less
		when placed over double-pane windows. Read our full <a
			href="/noise-disclaimer">Noise Reduction Sheet</a
		> to learn more.
	</p>
	<p>
		Increase the market value of your commercial space by making it more
		comfortable and quiet.
	</p>
	<p>Fill out the form below for a free estimate.</p>
</Section>

<GetAFreeEstimate />
<GradeTypes backgroundColor={'grey'} />
<Parallax image={image3} />
<Awards />
<FeaturedArticles />
